export const animationModes = {
    IDLE: 'IDLE',
    LISTENING: 'LISTENING',
    ENCOURAGING: 'ENCOURAGING',
    TALKING: 'TALKING',
} as const;
